import {
  IActiveTripResponseV2,
  ILastActiveTrips,
  ILastActiveTripsByStages,
  IMap,
  ITripsHistory,
  ITripState,
  IStationUserTripState
} from '../../../types'
import { mergeMap } from '../../../utils/state'
import { IStationUserTripsAction } from '../../actions/station-user-trips'
import * as constants from '../../constants/'

const initialState: IStationUserTripState = {
  isFetching: false,
  importResults: {},
  items: {},
  filters: {},
  lastActiveTrips: {},
  recentTrips: {},
  currentTripState: null,
  settings: {
    showMembers: false
  },
  currentTripId: ''
}

export function stationUserTrips(state: IStationUserTripState, action: IStationUserTripsAction): IStationUserTripState {
  if (typeof state === 'undefined') {
    return initialState
  }
  if (!action) {
    return state
  }

  switch (action.type) {
    case constants.STATION_USER_TRIPS_FETCH_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.STATION_USER_TRIPS_FETCH_SUCCESS: {
      return Object.assign({}, state, {
        items: action.payload,
        isFetching: false
      })
    }
  }
  return state
}

//   const initialTripsHistoryState: ITripsHistory = {
//     items: [],
//     isFetching: false,
//     error: '',
//     activeColumns: [
//       constants.TRIPS_HISTORY_COLUMNS.DATE,
//       constants.TRIPS_HISTORY_COLUMNS.PICKUP_TIME,
//       constants.TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME,
//       constants.TRIPS_HISTORY_COLUMNS.STATUS,
//       constants.TRIPS_HISTORY_COLUMNS.RIDER_NAME,
//       constants.TRIPS_HISTORY_COLUMNS.PROVIDER,
//       constants.TRIPS_HISTORY_COLUMNS.SERVICE,
//       constants.TRIPS_HISTORY_COLUMNS.COST,
//       constants.TRIPS_HISTORY_COLUMNS.FARE
//     ]
//   }

//   export function tripsHistory(state: ITripsHistory = initialTripsHistoryState, action: ITripAction): ITripsHistory {
//     if (!action) {
//       return state
//     }

//     switch (action.type) {
//       case constants.TRIPS_HISTORY_REQUEST: {
//         return Object.assign({}, state, { isFetching: true, items: {} })
//       }
//       case constants.TRIPS_HISTORY_SUCCESS: {
//         return Object.assign({}, state, {
//           isFetching: false,
//           items: action.payload,
//           lastUpdated: Date.now()
//         })
//       }
//       case constants.TRIPS_HISTORY_FAILURE: {
//         const error = action.payload
//         return Object.assign({}, state, { isFetching: false, items: {}, error })
//       }
//       case constants.TRIPS_HISTORY_UPDATE_COLUMNS: {
//         const columns = action.payload
//         return Object.assign({}, state, { activeColumns: columns })
//       }
//       default:
//         return state
//     }
//   }

//   const getUpdatedTripsStages = (
//     trips: IMap<IActiveTripResponseV2>,
//     tripStages: IMap<ILastActiveTrips>,
//     currentTripId: string,
//     currentStage: string
//   ) => {
//     return Object.entries({ ...tripStages }).reduce(
//       (acc, [stage, stageObject]) => {
//         const tripExistsInCurrentStage = stageObject.items.some((it: string) => it === currentTripId)
//         const copyOfStageObject = { ...stageObject }
//         if (tripExistsInCurrentStage && stage !== currentStage) {
//           copyOfStageObject.items = copyOfStageObject.items.filter((it: string) => it !== currentTripId)
//           copyOfStageObject.total = copyOfStageObject.total - 1
//         }
//         if (!tripExistsInCurrentStage && stage === currentStage) {
//           copyOfStageObject.items = [currentTripId, ...copyOfStageObject.items]
//           copyOfStageObject.total = copyOfStageObject.total + 1
//         }
//         return { [stage]: copyOfStageObject, ...acc }
//       },
//       {} as ILastActiveTripsByStages
//     )
//   }



// WEBPACK FOOTER //
// ./src/state/reducers/station-user-trips/index.ts